<template>
<div>
    <form-with-data :id="id" :isEdit="isEdit" ref="form" @submitLoad="submitLoad"></form-with-data>
    <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">保存</el-button>
         <el-button type="primary" @click="submitAndPublish" :loading="submitLoading">保存并发布</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
import formWithData from './withData'
export default {
  components: {
    formWithData
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      submitLoading: false
    //   publishLoading: false
    }
  },
  methods: {
    submit () {
      this.$refs.form.submit()
    },
    submitAndPublish () {
      this.$refs.form.submit(true)
    },
    // publishLoad (val) {
    //   this.publishLoading = val
    // },
    submitLoad (val) {
      this.submitLoading = val
    },
    cancel () {
      this.$confirm('你是否确定舍弃此次更改', '取消提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$router.push('/news-manage')
      })
    }
  }
}
</script>
<style module lang="less">

</style>
